export const phoneValidationError =
  "Phone number must be a valid phone number from US region";

export const requiredFieldValidationError = "Please, fill out this field.";
